import { api } from 'config';
import { Response } from 'types';

import { getUserCurrentStore } from 'utils/auth';

import { StoreSettings } from './types';

export async function getCashRegisterSettings(pageParam: number) {
  const storeUuid = getUserCurrentStore()?.uuid;

  const response = await api.get<Response<StoreSettings>>('/v1/cash-registers', {
    params: {
      store_uuid: storeUuid,
      page: pageParam,
    },
  });

  return response.data.data;
}
